/* Momuna · Manguera extensible (04-11-2026). Minijuego "Abrí la canilla" (sections/mm-mg-canilla).
   Mantener apretado = canilla abierta: t sube de 0 a 1 y la manguera se estira de ×1 a ×3 (máscara SVG sobre el mismo trazado,
   la pistola viaja a la punta). Al llegar a ×3 tira agua; al soltar, t baja sola a 0 y salta la tarjeta de compra.
   requestAnimationFrame solo mientras t cambia; nada corre en reposo. La compra la maneja mm-org.js ([data-org-cta]). */
(function () {
  if (window.__mmMg) return; window.__mmMg = true;
  var D = document, W = window;
  var reducido = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SUBE = reducido ? 1 / 900 : 1 / 2300, BAJA = reducido ? 1 / 700 : 1 / 1700; /* por milisegundo */
  function vibrar(ms) { if (navigator.vibrate) { try { navigator.vibrate(ms); } catch (e) {} } }
  function publicar(nombre, datos) { try { W.dispatchEvent(new CustomEvent('momuna:landing', { detail: { evento: 'canilla-' + nombre, datos: datos || {} } })); } catch (e) {} }

  function iniciar(root) {
    var q = function (s) { return root.querySelector(s); };
    var mask = q('[data-mg-mask]'), pist = q('[data-mg-pistola]'), giro = q('[data-mg-pistola-giro]');
    var xEl = q('[data-mg-x]'), lbl = q('[data-mg-lbl]'), msg = q('[data-mg-msg]');
    var boton = q('[data-mg-boton]'), auto = q('[data-mg-auto]'), fin = q('[data-mg-fin]'), otra = q('[data-mg-otra]');
    if (!mask || !boton) return;
    var total = mask.getTotalLength();
    var t = 0, abierto = false, lleno = false, terminado = false, corriendo = false, ultimo = 0, automatico = false, ultimoMsg = '';
    var T = function (k) { return root.getAttribute('data-' + k) || ''; };
    function decir(k) { var s = T(k); if (s && s !== ultimoMsg) { msg.textContent = s; ultimoMsg = s; } }

    function pintar() {
      var L = total * (1 / 3 + t * 2 / 3);
      mask.setAttribute('stroke-dasharray', L.toFixed(1) + ' ' + (total + 40).toFixed(0));
      var p = mask.getPointAtLength(L), a = mask.getPointAtLength(Math.max(0, L - 3));
      var ang = Math.atan2(p.y - a.y, p.x - a.x) * 180 / Math.PI;
      pist.setAttribute('transform', 'translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ') rotate(' + ang.toFixed(1) + ')');
      giro.setAttribute('transform', Math.cos(ang * Math.PI / 180) < 0 ? 'scale(1.15 -1.15)' : 'scale(1.15)');
      root.style.setProperty('--t', t.toFixed(3));
      var x = 1 + t * 2;
      xEl.textContent = t >= 1 ? '×3' : (t <= 0 ? '×1' : '×' + x.toFixed(1).replace('.', ','));
      lbl.textContent = t >= 1 ? T('l-llena') : (t <= 0 ? T('l-cerrada') : (abierto ? T('l-crece') : T('l-achica')));
    }

    function paso(ahora) {
      var dt = Math.min(64, ahora - ultimo); ultimo = ahora;
      if (abierto) t = Math.min(1, t + dt * SUBE); else t = Math.max(0, t - dt * BAJA);
      pintar();
      if (abierto && t >= 1 && !lleno) {
        lleno = true; root.classList.add('is-lleno', 'is-chorro'); decir('t-lleno'); vibrar([14, 40, 22]); publicar('lleno');
      }
      if (!abierto && t <= 0) { corriendo = false; alCerrarDelTodo(); return; }
      if (abierto && t >= 1) { corriendo = false; return; }
      W.requestAnimationFrame(paso);
    }
    function mover() { if (!corriendo) { corriendo = true; ultimo = performance.now(); W.requestAnimationFrame(paso); } }

    function abrir() {
      if (terminado || abierto) return;
      abierto = true; root.classList.add('is-agua', 'is-tocado'); boton.setAttribute('aria-pressed', 'true');
      if (lleno) root.classList.add('is-chorro');
      if (!lleno) decir('t-crece');
      vibrar(10); mover();
    }
    function cerrar() {
      if (!abierto) return;
      abierto = false; root.classList.remove('is-agua', 'is-chorro'); boton.setAttribute('aria-pressed', 'false');
      decir(lleno ? 't-achica' : 't-corto'); mover();
    }
    function alCerrarDelTodo() {
      pintar();
      if (!lleno || terminado) return;
      terminado = true; decir('t-fin'); root.classList.add('is-fin'); root.classList.remove('is-lleno');
      fin.hidden = false;
      W.requestAnimationFrame(function () { W.requestAnimationFrame(function () { fin.classList.add('is-on'); }); });
      var r = fin.getBoundingClientRect();
      if (r.bottom > (W.innerHeight || 800) - 20) fin.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'center' });
      vibrar(18); publicar('fin', { automatico: automatico });
      automatico = false; auto.disabled = false;
    }
    function reiniciar() {
      terminado = false; lleno = false; t = 0; abierto = false;
      root.classList.remove('is-fin', 'is-lleno', 'is-chorro', 'is-agua');
      fin.classList.remove('is-on'); fin.hidden = true; ultimoMsg = ''; decir('t-inicio'); pintar();
      boton.focus({ preventScroll: true });
    }

    /* mantener apretado: puntero (dedo o mouse), teclado (espacio/Enter) y la canilla del dibujo */
    boton.addEventListener('pointerdown', function (e) {
      if (automatico) return; e.preventDefault();
      try { boton.setPointerCapture(e.pointerId); } catch (er) {}
      abrir();
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) { boton.addEventListener(n, function () { if (!automatico) cerrar(); }); });
    boton.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    boton.addEventListener('keydown', function (e) {
      if ((e.key === ' ' || e.key === 'Enter') && !e.repeat && !automatico) { e.preventDefault(); abrir(); }
    });
    boton.addEventListener('keyup', function (e) { if ((e.key === ' ' || e.key === 'Enter') && !automatico) { e.preventDefault(); cerrar(); } });
    boton.addEventListener('click', function (e) { e.preventDefault(); });
    W.addEventListener('blur', function () { if (!automatico) cerrar(); });

    auto.addEventListener('click', function () {
      if (automatico || terminado) return;
      automatico = true; auto.disabled = true; publicar('mostrame');
      abrir();
      var espera = W.setInterval(function () {
        if (lleno) { W.clearInterval(espera); W.setTimeout(function () { abierto = true; cerrar(); }, 1300); }
      }, 80);
    });
    otra.addEventListener('click', reiniciar);
    pintar();
  }

  function todo() { D.querySelectorAll('[data-mg-canilla]').forEach(iniciar); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', todo); else todo();
})();
